/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Transfer data object for deleteting event
 * @export
 * @interface WebApiServicesDataTransferObjectsUserServiceDeleteEventResultDto
 */
export interface WebApiServicesDataTransferObjectsUserServiceDeleteEventResultDto {
    /**
     * Gets or sets the identifier.
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsUserServiceDeleteEventResultDto
     */
    id?: number;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsUserServiceDeleteEventResultDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsUserServiceDeleteEventResultDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsUserServiceDeleteEventResultDtoFromJSON(json: any): WebApiServicesDataTransferObjectsUserServiceDeleteEventResultDto {
    return WebApiServicesDataTransferObjectsUserServiceDeleteEventResultDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsUserServiceDeleteEventResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsUserServiceDeleteEventResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function WebApiServicesDataTransferObjectsUserServiceDeleteEventResultDtoToJSON(value?: WebApiServicesDataTransferObjectsUserServiceDeleteEventResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

